(function (jQuery) {
  jQuery.gfBackgroundPosition = function (element, options) {
    const defaults = {
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);

    const _this = this;
    let _type = '';
    const _size = {
      x: '',
      y: '',
    };

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      if ($element.attr('value')) {
        _type = $element.attr('value');
      }
      if (_type == '') {
        _type = $element.attr('default_value');
      }

      _this.setTemplate();
      $element.on('value-change', function () {
        const value = $(this).attr('value');
        _this.setValue(value);
      });
    };

    this.setTemplate = function () {
      let desc = '';
      if ($element.attr('data-description')) {
        desc = $element.attr('data-description');
      }

      const _template =
        ' <div class="gfBackgroundPosition"> <div class="gfSGSubTitle">' +
        _this.settings.title +
        '</div><div class="gfSGclear"></div><div class="gfBPositionBody"> <div class="gfBPLeft"> <div data-value="left top" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10"> <path d="M2,2v6H0V0h8v2H2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="center top" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10"> <path d="M10,2H0V0h10V2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="right top" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(90deg);"> <path d="M2,2v6H0V0h8v2H2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="left center" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(-90deg);"> <path d="M10,2H0V0h10V2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="center center" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10"> <circle class="st1" cx="5" cy="5" r="3" style="fill: #DADADB;" /> </svg> </div> <div data-value="right center" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(90deg);"> <path d="M10,2H0V0h10V2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="left bottom" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(-90deg);"> <path d="M2,2v6H0V0h8v2H2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="center bottom" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(180deg);"> <path d="M10,2H0V0h10V2z" style="fill: #DADADB;" /> </svg> </div> <div data-value="right bottom" class="gfBPItem"> <svg class="help-me-name-it-bruh" height="10px" viewBox="0 0 10 10" style="transform: rotate(180deg);"> <path d="M2,2v6H0V0h8v2H2z" style="fill: #DADADB;" /> </svg> </div> </div> <div class="gfBPRight"> <div class="gfBPX"> <span>X-pos</span> <input name="xpos" type="text" unit="%" default_value="0%" /> </div> <div class="gfBPY"> <span>Y-pos</span> <input name="ypos" type="text" unit="%" default_value="0%" /> </div> </div> </div> </div>';
      $element.after(_template);

      const $gfBackgroundPosition = $element.next('.gfBackgroundPosition');

      $gfBackgroundPosition.find('.gfBPX input').gfInputField({
        onValueChanged: function (value) {
          let xPos = jQuery.trim(value) == '' ? 0 : jQuery.trim(value);
          xPos = xPos + '%';
          const yPos = $gfBackgroundPosition.find('.gfBPY input').val();

          _this.updateValue(xPos, yPos);

          const quickPosString = xPos + ' ' + yPos;
          $element.attr('value', quickPosString).val(quickPosString).trigger('input-change');
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });
      $gfBackgroundPosition.find('.gfBPY input').gfInputField({
        onValueChanged: function (value) {
          const xPos = $gfBackgroundPosition.find('.gfBPX input').val();
          let yPos = jQuery.trim(value) == '' ? 0 : jQuery.trim(value);
          yPos = yPos + '%';

          _this.updateValue(xPos, yPos);

          const quickPosString = xPos + ' ' + yPos;
          $element.attr('value', quickPosString).val(quickPosString).trigger('input-change');
        },
        onHistoryAdded: function () {
          $element.trigger('history-change');
        },
      });

      const $sliderXInit = $gfBackgroundPosition.find('.gfBPX input');
      const $sliderX = $gfBackgroundPosition.find('.gfBPX input').next('.gfInputField').find('input');
      const $sliderYInit = $gfBackgroundPosition.find('.gfBPY input');
      const $sliderY = $gfBackgroundPosition.find('.gfBPY input').next('.gfInputField').find('input');

      _this.setValue(_type);

      // Callback on Click
      const $btnClick = $gfBackgroundPosition.find('.gfBPLeft .gfBPItem');

      $btnClick.click(function () {
        const item = $(this).attr('data-value');
        if (!$(this).hasClass('active')) {
          $gfBackgroundPosition.find('.gfBPLeft .gfBPItem').removeClass('active');
          $(this).addClass('active');
          _type = item;

          $sliderXInit.data('gfinputfield').setCurrentUnit('%');
          $sliderYInit.data('gfinputfield').setCurrentUnit('%');

          const value = jQuery(this).attr('data-value');
          switch (value) {
            case 'left top':
              $sliderX.val(0);
              $sliderY.val(0);
              break;
            case 'center top':
              $sliderX.val(50);
              $sliderY.val(0);
              break;
            case 'right top':
              $sliderX.val(100);
              $sliderY.val(0);
              break;

            case 'left center':
              $sliderX.val(0);
              $sliderY.val(50);
              break;
            case 'center center':
              $sliderX.val(50);
              $sliderY.val(50);

              break;
            case 'right center':
              $sliderX.val(100);
              $sliderY.val(50);

              break;
            case 'left bottom':
              $sliderX.val(0);
              $sliderY.val(100);
              break;
            case 'center bottom':
              $sliderX.val(50);
              $sliderY.val(100);
              break;
            case 'right bottom':
              $sliderX.val(100);
              $sliderY.val(100);
              break;
          }

          $sliderXInit
            .attr('value', $sliderX.val() + $sliderXInit.data('gfinputfield').getCurrentUnit())
            .val($sliderX.val() + $sliderXInit.data('gfinputfield').getCurrentUnit())
            .trigger('value-change');
          $sliderYInit
            .attr('value', $sliderY.val() + $sliderYInit.data('gfinputfield').getCurrentUnit())
            .val($sliderY.val() + $sliderYInit.data('gfinputfield').getCurrentUnit())
            .trigger('value-change');

          _this.onChangeValue('change');
          $element.attr('value', value).val(value).trigger('input-change').trigger('history-change');
        }
      });
      $sliderX.off('mousedown.bg').on('mousedown.bg', function (e) {
        let $that = jQuery(this),
          start = e.pageY,
          end,
          old = parseInt($that.val()) || 0;

        const isDragging = true;

        $gfLeftSideBar.on('mousemove.bg', function (e) {
          end = e.pageY;
          const newVar = old + Math.floor((start - end) / 2);
          $that.val(newVar);

          $sliderXInit
            .attr('value', newVar + $sliderXInit.data('gfinputfield').getCurrentUnit())
            .val(newVar + $sliderXInit.data('gfinputfield').getCurrentUnit())
            .trigger('value-change');

          const xPos = $gfBackgroundPosition.find('.gfBPX input').val();
          const yPos = $gfBackgroundPosition.find('.gfBPY input').val();
          _this.updateValue(xPos, yPos);

          const quickPosString = xPos + ' ' + yPos;
          $element.attr('value', quickPosString).val(quickPosString).trigger('input-change');
          _this.onChangeValue('change');
        });
        $gfLeftSideBar.on('mouseup.bg', function (e) {
          $gfLeftSideBar.off('mouseup.bg');
          $gfLeftSideBar.off('mousemove.bg');
        });
      });
      $sliderY.off('mousedown.bg').on('mousedown.bg', function (e) {
        let $that = jQuery(this),
          start = e.pageY,
          end,
          old = parseInt($that.val()) || 0;

        const isDragging = true;

        $gfLeftSideBar.on('mousemove.bg', function (e) {
          end = e.pageY;
          const newVar = old + Math.floor((start - end) / 2);
          $that.val(newVar);
          $sliderYInit
            .attr('value', newVar + $sliderYInit.data('gfinputfield').getCurrentUnit())
            .val(newVar + $sliderYInit.data('gfinputfield').getCurrentUnit())
            .trigger('value-change');

          const xPos = $gfBackgroundPosition.find('.gfBPX input').val();
          const yPos = $gfBackgroundPosition.find('.gfBPY input').val();
          _this.updateValue(xPos, yPos);

          const quickPosString = xPos + ' ' + yPos;
          $element.attr('value', quickPosString).val(quickPosString).trigger('input-change');
          _this.onChangeValue('change');
        });
        $gfLeftSideBar.on('mouseup.bg', function (e) {
          $gfLeftSideBar.off('mouseup.bg');
          $gfLeftSideBar.off('mousemove.bg');
        });
      });

      return false;
    };

    _this.onChangeValue = function (type) {
      const $gfBackgroundPosition = $element.next('.gfBackgroundPosition');
      const $sliderX = $gfBackgroundPosition.find('.gfBPX input');
      const $sliderY = $gfBackgroundPosition.find('.gfBPY input');

      _size['x'] = $sliderX.val();
      _size['y'] = $sliderY.val();

      return false;
    };

    this.setValue = function (value) {
      const quickPos = value.split(' ');
      let quickPos1 = '';
      let quickPos2 = '';

      let xPos = '0%';
      let yPos = '0%';

      if (quickPos.length > 1) {
        switch (quickPos[0]) {
          case '0%':
            quickPos1 = 'left';
            break;
          case '50%':
            quickPos1 = 'center';
            break;
          case '100%':
            quickPos1 = 'right';
            break;
        }
        switch (quickPos[1]) {
          case '0%':
            quickPos2 = 'top';
            break;
          case '50%':
            quickPos2 = 'center';
            break;
          case '100%':
            quickPos2 = 'bottom';
            break;
        }

        xPos = quickPos[0];
        yPos = quickPos[1];
      }
      const quickPosString = quickPos1 + ' ' + quickPos2;

      const $gfBackgroundPosition = $element.next('.gfBackgroundPosition');
      $gfBackgroundPosition.find('.gfBPItem').removeClass('active');
      $gfBackgroundPosition.find('.gfBPItem[data-value="' + quickPosString + '"]').addClass('active');

      $gfBackgroundPosition.find('input[name="xpos"]').val(xPos).attr('value', xPos).trigger('value-change');
      $gfBackgroundPosition.find('input[name="ypos"]').val(yPos).attr('value', yPos).trigger('value-change');

      //Change display;
      _type = value;
      _this.onChangeValue('set');
      return false;
    };

    this.updateValue = function (xPos, yPos) {
      let found = true;
      switch (xPos) {
        case '0%':
          xPos = 'left';
          break;
        case '50%':
          xPos = 'center';
          break;
        case '100%':
          xPos = 'right';
          break;

        default:
          found = false;
          break;
      }
      switch (yPos) {
        case '0%':
          yPos = 'top';
          break;
        case '50%':
          yPos = 'center';
          break;
        case '100%':
          yPos = 'bottom';
          break;

        default:
          found = false;
          break;
      }
      const $gfBackgroundPosition = $element.next('.gfBackgroundPosition');
      $gfBackgroundPosition.find('.gfBPItem').removeClass('active');

      if (found) {
        const quickPosString = xPos + ' ' + yPos;
        $gfBackgroundPosition.find('.gfBPItem[data-value="' + quickPosString + '"]').addClass('active');
      }

      return false;
    };

    this.init();
  };
  jQuery.fn.gfBackgroundPosition = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfbackgroundposition')) {
        const plugin = new jQuery.gfBackgroundPosition(this, options);
        jQuery(this).data('gfbackgroundposition', plugin);
      }
    });
  };
})(jQuery);
